$(document).ready(function () {
  // $('.slicknav_nav').attr('tabindex','-1');
  // $('.slicknav_nav').focus();
  $('.paginate span.current').attr('aria-current','page');
  $('.paginate span.next a').attr('aria-label','Next page');
  $('.template_order .li_border img').attr('alt','img');
  $('.sidebar.sidebar--blog h6').attr('aria-level','3');
  $('.shopify-section--featured-collection .collctn_temp h2').attr('aria-level','3');
  $('.paginate span.deco').attr('aria-hidden','true');
  // $('.shopify-section--collection-template .collctn_temp h3').attr('aria-level','2');
  $('#nav ul li.dropdown.sub-menu summary').removeAttr('href');
  $('a[href="/pages/accessibility-statement"]').attr('id','accesibility-statement');
  // $('#mobile_nav .slicknav_menu > a').removeAttr('href');
  // $('#mobile_nav .slicknav_menu > a').attr('aria-expanded','false');
  $('br').attr('aria-hidden','true');
  $('hr').attr('aria-hidden','true');
  $('.has-sidebar-option,.sda-phone-capture,.collection-description h2,h3,h4,h5').each(function () {
    if ($(this).html().trim() === '') {
      $(this).remove();
    }
  });
  jQuery(".paginate span a").each(function() {
    var ariaTitle = jQuery(this).text().trim();
    jQuery(this).attr("aria-label", 'Page: ' + ariaTitle);
  });

  if (window.location.pathname.includes('/blogs/')) {
    document.querySelectorAll('a[title]').forEach(link => {
        link.removeAttribute('title');
    });
  }

    var existCondition = setInterval(function() {
     if ($('.delivery_msg').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
     console.log("alt adding");
    $('.delivery_msg img').attr('alt','');
    $('.delivery_msg img').attr('aria-hidden','true');
    $('.delivery_msg br').attr('aria-hidden','true');
    }
//back to top
// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function() {
  scrollFunction();
};
 
function scrollFunction() {
  if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
    document.getElementById("back-to-top").style.display = "block";
  } else {
    document.getElementById("back-to-top").style.display = "none";
  }
}
 
// When the user clicks on the button, scroll to the top of the document
document.getElementById("back-to-top").onclick = function() {
  scrollToTop();
};
 
function scrollToTop() {
  const scrollStep = -window.scrollY / (500 / 15);
  const scrollInterval = setInterval(function() {
    if (window.scrollY !== 0) {
      window.scrollBy(0, scrollStep);
    } else {
      clearInterval(scrollInterval);
    }
  }, 15);
}
    
    $("li.sub-menu ul.submenu_list li.sub-menus").click(function() {
      const $dropdown = $(this).find(".sub-btn"); 
    
      if ($dropdown.attr("aria-expanded") === "false") {
        $("li.sub-menu ul.submenu_list li.sub-menus > .sub-btn").attr("aria-expanded", "false");
        $("li.sub-menu ul.submenu_list li.sub-menus").removeClass("active");
        
        $dropdown.attr("aria-expanded", "true");
        $(this).addClass("active");
        
      } else {
        $dropdown.attr("aria-expanded", "false");
        $(this).removeClass("active");
        
      }
    });
  
    $(document).on('focusin', function(event) {
      if ($(event.target).closest(".sub-menus").length === 0) {
        $(".sub-btn").attr("aria-expanded", "false");
        $("li.sub-menus").removeClass("active");
        
      }
    });


  $('a').each(function () {
    if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'https://www.getairsports.com') {
      var warningSpan = $('<span class="visuallyhidden">: This link will open in a new tab.</span>');
      $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
      $(this).append(warningSpan);
    }
  });

});


$(document).ready(function () {
  setTimeout(function () {
    

    $(".tns-inner .bloggle_product--infos").each(function (i) {
      $(this).detach().appendTo($(".bggle_product-container").eq(i))
    });
    
    $(".tns-inner .bggle_button-link button").each(function (i) {
      $(this).detach().appendTo($(".bloggle_product--infos").eq(i))
    });
    
    $(".tns-inner .bloggle_product--infos .bloggle_product--title").each(function (i) {
      $(this).detach().appendTo($(".bggle_button-link").eq(i))
    });
    
    $(".tns-outer").attr("role", "region");
    $(".tns-outer").attr("aria-label", "Product Carousel");
    $(".tns-controls button[data-controls='prev']").attr("aria-label", "Previous");
  
    $(".bloggle_product--title").attr("aria-hidden", "true");
    
    var newDiv = $('<span>Regular price: </span>').prependTo('.tns-inner .bloggle_product--price-currency');
    
    newDiv.addClass('visuallyhidden');



    var element = $(".bloggle_product--infos button");
    element.replaceWith(function() {
        return $("<a>", {
            class: $(this).attr("class"),
            html: $(this).html() 
        });
    });
    element = $(".elementor-accordion-title");

    $(".bggle_product-container").each(function() {
      var neoclmn = $(this);
      var link = neoclmn.find(".bggle_button-link");
      var linktc = neoclmn.find("a");
      
      var linkText = link.attr('href');
      
      linktc.attr("href", linkText);
      });


  }, 3000);
}, 3000);

// Remove 'open' attribute from <details> when Esc key is pressed
$(document).on('keydown', function(event) {
  if (event.key === "Escape") {
    $("details[open]").removeAttr("open");
  }
});
